<p-table
	#dt
	styleClass="p-datatable-responsive-demo"
	[value]="dealerService.dealer.value.venues"
	[loading]="!dealerService.dealer.value.venues"
	[globalFilterFields]="app.keys(dealerService.dealer.value.venues)"
	[scrollable]="true"
	[rows]="100"
	scrollHeight="700px"
	[virtualScroll]="true"
	[virtualRowHeight]="40"
>
	<ng-template pTemplate="caption">
		<div class="table-header d-flex">
			<div class="flex-grow-1">
				<span class="p-float-label p-input-icon-left m-2 w-100">
					<i class="pi pi-search"></i>
					<input
						pInputText
						class="w-100"
						id="globalSearch"
						name="globalSearch"
						style="width: 100%"
						type="text"
						(input)="dt.filterGlobal($event.target.value, 'contains')"
					/>
					<label for="globalSearch">Search...</label>
				</span>
			</div>
		</div>
	</ng-template>
	<ng-template pTemplate="header">
		<tr>
			<th pSortableColumn="name">
				Name
				<p-sortIcon field="name"></p-sortIcon>
			</th>
			<th pSortableColumn="key">
				VenueKey
				<p-sortIcon field="key"></p-sortIcon>
			</th>
			<th>Accounting Link</th>
		</tr>
	</ng-template>
	<ng-template let-rec pTemplate="body">
		<tr>
			<td>
				{{ rec.name }}
			</td>
			<td>
				{{ rec.key }}
			</td>
			<td>
				<span class="p-float-label">
					<p-dropdown
						#accountingLink{{rec.key}}
						[options]="accountingCustomerList"
						optionLabel="name"
						optionValue="value"
						name="accountingLink{{ rec.key }}"
						[(ngModel)]="rec.externalDealerAccountingId"
						[style]="{ width: '100%' }"
						appendTo="body"
						[autoDisplayFirst]="false"
						[virtualScroll]="true"
						virtualScrollItemSize="30"
						filter="true"
						(filterBy)="app.keys(accountingCustomerList)"
						(onChange)="setVenueAccountingId(rec.key)"
					></p-dropdown>
					<label for="accountingLink{{ rec.key }}">Accounting Customer</label>
				</span>
			</td>
		</tr>
	</ng-template>
</p-table>
